/* Sunkissed custom (Oct 8 2026): no size preselected for single pieces.
   On a product page (and in the mobile quick-add sheet) a product with a Size option and more than
   one variant loads with no size picked (in the quick-add sheet a set's Top and Bottom rows too).
   The Add button reads "Pick your size" (greyed) until a size is tapped; an early tap adds nothing
   and scrolls to / flashes the size row.
   Skipped: set pages (sk-set-page.js handles them), one-size products, and links with ?variant=
   (an explicit choice from an ad or link is kept). Other scripts can ask window.skSizeGate.
   Oct 12 2026: the price shows in the shopper's own currency (window.SK_INTL, snippets/sk-intl.liquid). */
(function () {
  'use strict';
  var DEEP = /[?&]variant=\d+/.test(location.search);
  function money(c) { if (window.SK_INTL) return SK_INTL.money(c); var v = c / 100; return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }

  // Size rows to hold back: the Size row of a single piece; in the quick-add sheet also the Top and
  // Bottom rows of a set (on a set page sk-set-page.js does this)
  function sizeWraps(scope, isPage) {
    var out = [], ws = scope.querySelectorAll('.selector-wrapper');
    var names = Array.prototype.map.call(ws, function (w) { var n = w.querySelector('.radio__legend__option-name'); return n ? n.textContent.trim() : ''; });
    var isSet = names.filter(function (n) { return /top|bottom/i.test(n); }).length > 1;
    if (isSet && isPage) return out;
    for (var i = 0; i < ws.length; i++) {
      if (ws[i].querySelectorAll('input[type="radio"]').length < 2) continue;
      if (isSet ? /top|bottom/i.test(names[i]) : /size/i.test(names[i])) { out.push(ws[i]); if (!isSet) break; }
    }
    return out;
  }
  function unpicked(scope) { return (scope.__skGates || []).filter(function (w) { return !w.querySelector('input[type="radio"]:checked'); }); }
  function btnOf(scope) { return scope.querySelector('form[action*="/cart/add"] [data-add-to-cart]') || scope.querySelector('[data-add-to-cart]'); }
  function pending(scope) {
    if (!scope || !scope.__skGates || !scope.classList.contains('sk-size-pending')) return false;
    return unpicked(scope).length > 0;
  }
  function waitLabel(scope) {
    var w = unpicked(scope)[0], n = w && w.querySelector('.radio__legend__option-name');
    var t = n ? n.textContent : '';
    if ((scope.__skGates || []).length > 1) { if (/bottom/i.test(t)) return 'Pick bottom size'; if (/top/i.test(t)) return 'Pick top size'; }
    return 'Pick your size';
  }
  function fromPrice(scope) {
    var host = scope.closest('[data-section-type]') || scope;
    var el = host.querySelector('[data-product-json]') || scope.querySelector('[data-product-json]');
    try {
      var p = JSON.parse(el.textContent);
      var ps = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) { return v.price; });
      if (!ps.length) ps = (p.variants || []).map(function (v) { return v.price; });
      return ps.length ? money(Math.min.apply(null, ps)) : '';
    } catch (e) { return ''; }
  }
  function paint(scope) {
    if (!pending(scope)) return false;
    var btn = btnOf(scope); if (!btn) return true;
    var txt = btn.querySelector('[data-add-to-cart-text]');
    if (scope.__skPrice == null) scope.__skPrice = fromPrice(scope);
    var html = waitLabel(scope) + '<span class="btn__price" data-product-price>' + scope.__skPrice + '</span>';
    if (txt && txt.innerHTML !== scope.__skHtml) { txt.innerHTML = html; scope.__skHtml = txt.innerHTML; } // compare serialized form (no repaint loop)
    btn.disabled = false;
    btn.classList.add('sk-btn-wait');
    if (scope.classList.contains('product__page')) document.documentElement.classList.add('sk-need-size');
    return true;
  }
  function setup(scope, isPage) {
    if (!scope || scope.__skGateDone) return;
    scope.__skGateDone = true;
    if (isPage && DEEP) return;
    var gates = sizeWraps(scope, isPage); if (!gates.length) return;
    gates.forEach(function (w) {
      Array.prototype.forEach.call(w.querySelectorAll('input[type="radio"]'), function (r) { r.checked = false; r.removeAttribute('checked'); });
      var val = w.querySelector('[data-option-value]'); if (val) val.textContent = '';
    });
    scope.__skGates = gates;
    scope.classList.add('sk-size-pending');
    paint(scope);
    // the theme or other scripts may repaint the button; keep the wait state until a size is picked
    var btn = btnOf(scope);
    if (btn && window.MutationObserver) new MutationObserver(function () { if (pending(scope)) paint(scope); }).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }
  function scopeOf(el) { return el.closest('dialog[data-quick-add-modal]') || el.closest('.product__page'); }

  // First size tap ends the wait state; the theme then paints the normal button
  document.addEventListener('change', function (e) {
    var r = e.target; if (!r || r.type !== 'radio' || !r.closest) return;
    var s = scopeOf(r); if (!s || !s.__skGates || !s.classList.contains('sk-size-pending')) return;
    if (!s.__skGates.some(function (w) { return w.contains(r); })) return;
    if (unpicked(s).length) { s.__skHtml = null; setTimeout(function () { paint(s); }, 0); return; } // a set row is still open
    s.classList.remove('sk-size-pending');
    var btn = btnOf(s); if (btn) btn.classList.remove('sk-btn-wait');
    if (s.classList.contains('product__page')) document.documentElement.classList.remove('sk-need-size');
  }, true);

  // Early tap: add nothing, show the size row (window capture runs before every other add handler)
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-add-to-cart]'); if (!b) return;
    var s = scopeOf(b); if (!pending(s)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var w = unpicked(s)[0] || s.__skGates[0];
    if (s.tagName === 'DIALOG') w.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else window.scrollTo({ top: w.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
    w.classList.remove('sk-flash'); void w.offsetWidth; w.classList.add('sk-flash');
  }, true);

  function init() {
    setup(document.querySelector('.product__page'), true);
    Array.prototype.forEach.call(document.querySelectorAll('dialog[data-quick-add-modal]'), function (d) { if (d.querySelector('.selector-wrapper')) setup(d, false); });
    if (window.MutationObserver) new MutationObserver(function (list) {
      list.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1 && n.matches && n.matches('dialog[data-quick-add-modal]')) setTimeout(function () { setup(n, false); }, 0); }); });
    }).observe(document.body, { childList: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.skSizeGate = { pending: pending, paint: paint };
})();
